import { z } from 'zod';

export const passwordSchema = z
    .string()
    .min(8, { message: 'Must be at least 8 characters' })
    .refine((value) => /[A-Z]/.test(value), {
        message: 'Must contain at least one uppercase character',
    })
    .refine((value) => /[a-z]/.test(value), {
        message: 'Must contain at least one lowercase character',
    })
    .refine((value) => /\d/.test(value), {
        message: 'Must contain at least one number',
    })
    .refine((value) => /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(value), {
        message: 'Password must contain a special character',
    });

export const ChangePasswordSchema = z
    .object({
        newPassword: passwordSchema,
        retypeNewPassword: passwordSchema,
    })
    .refine((data) => data.newPassword === data.retypeNewPassword, {
        message: 'Passwords do not match',
        path: ['retypeNewPassword'],
    });

export enum province {
    A = 'a',
    B = 'AB',
    C = 'BC',
    D = 'MB',
    E = 'NB',
    F = 'NL',
    G = 'NT',
    H = 'NS',
    I = 'NU',
    J = 'ON',
    K = 'PE',
    L = 'QC',
    M = 'SK',
    N = 'YT',
}
